<template>
  <div class="flex-grow-1 padding">
    <h4 class="mt-0" style="color: black; font-style: normal; font-weight: 600; font-size: 13px; line-height: 35px;">
      Product specific settings
    </h4>
    <div class="content-wrapper card-wrapper">
      <div class="card raw-table-body">
        <div>
          <div class="table-content">
            <div class="ComposableTable d-flex">
              <table class="table w-full mb-0">
                <thead>
                  <tr>
                    <th class="py-1 px-2 table-cell" width="30%">
                      LABEL
                    </th>
                    <th class="py-1 px-2 table-cell" width="40%">
                      DEFAULT VALUE
                    </th>
                    <th class="py-1 px-2 table-cell" width="30%">
                      TYPE
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in productSettings" :key="index">
                    <td width="30%">
                        <FormInput class="form-element" v-model="item.label" />
                      </td>
                      <td width="40%">
                        <FormInput class="form-element" v-model="item.value" />
                      </td>
                    <td width="30%">
                      <FormSelect style="width: 100%; margin: 0;" v-model="item.type" :options="types"></FormSelect>

                      <button class="ml-2" @click="removeField(index)">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1.5 10.5L10.5 1.5M1.5 1.5L10.5 10.5" stroke="#6B7280" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <button type="button" class="btn btn-primary" @click="addField">
                        New Field
                      </button>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h4 class="mt-0" style="color: black; font-style: normal; font-weight: 600; font-size: 13px; line-height: 35px;">
      Selected settings
    </h4>
    <div class="content-wrapper card-wrapper">
      <div class="card raw-table-body">
        <div>
          <div class="table-content">
            <div class="ComposableTable d-flex">
              <table class="table w-full mb-0">
                <thead>
                  <tr>
                    <th class="py-1 px-2 table-cell" width="50%">
                      Name
                    </th>
                    <th class="py-1 px-2 table-cell" width="50%">
                      Fields
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in settings" :key="index">
                    <td width="50%">
                      <input type="checkbox"
                        v-model="item.selected"
                        @click="toggleSetting(item.uid, !item.selected)" class="form-checkbox"
                        style="width: 15px; vertical-align: middle;"
                        :disabled="item.selected && item.type == 'global'" />
                      {{ item.name }}
                    </td>
                    <td width="50%">
                      {{ item.fields }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableTemplate from 'src/layout/Table/TableTemplate'
import FormSelect from "src/components/Inputs/FormSelect.vue"
import table from "src/mixins/table"
import tableFieldOptions from "src/mixins/tableFieldOptions"
import FormInput from "src/components/Inputs/FormInput.vue"

export default {
  name: "SupplierSettingSection",
  components: {
    TableTemplate,
    FormSelect,
    FormInput
  },
  mixins: [
    tableFieldOptions
  ],
  props: {
    initialSettings: Array,
    initialProductSetting: Array,
    productId: String
  },
  data() {
    return {
      productSettings: this.initialProductSetting || [],
      settings: this.initialSettings || [],
      types: [
        {
          value: "text",
          str: "Text"
        },
        {
          value: "boolean",
          str: "Boolean"
        },
        {
          value: "number",
          str: "Number"
        }
      ]
    }
  },
  computed: {
    table() {
      return this.$refs.table
    },
    websiteColumns() {
      return ['LABEL', 'TYPE']
    },
    websiteColumnVariables() {
      return ['name']
    },
    capitalize() {
      return [false]
    },
    setting_ids(){
      return this.settings.filter(e => e.selected === true).map(e => e.uid)
    }
  },
  methods: {
    addField() {
      this.productSettings.push({
        label: null,
        value: null,
        type: "text"
      })
    },
    removeField(index) {
      this.productSettings.splice(index, 1)
    },
    toggleSetting(uid, selected) {
      let setting_ids = []
      if (selected) {
        setting_ids = Array.from(new Set([...this.setting_ids, uid]))
      } else {
        setting_ids = this.setting_ids.filter(e => e !== uid);
      }
      this.$handlePromise(
        (async () => {
          await this.axios.put(`/api/products/${this.productId}/settings`, { setting_ids })
          this.$success("Product heeft de instellingen succesvol toegevoegd!")
          if (this.$refs.column) {
            this.$refs.column.resetAndRefetch()
          }
        })()
      )
    }
  },
  watch: {
    initialProductSetting(val) {
      this.productSettings = val
    },
    initialSettings(val) {
      this.settings = val
    },
    productSettings(val) {
      this.$emit("set-settings", val)
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: unset !important
}
</style>